<template>
    <div class="gw-ranking-provider-discount" v-if="content">
        <template v-for="(provider, key) in this.providers">
            <a
                v-if="provider['provider_id'] === content"
                :href="gotoLink(provider)"
                :key="'gw_ranking_partner_' + key"
                target="_blank"
            >
                <div class="heading">
                    <div class="ribbon">
                        &#10041; {{ $t('HOT TIME OFFER') }} |
                        <span>
                            {{ $t('Only') }}
                            {{ formatUnitValue(countdownTimer.hours) }}
                            {{ $t('hours') }}
                            {{ formatUnitValue(countdownTimer.minutes) }}
                            {{ $t('m') }}
                            {{ formatUnitValue(countdownTimer.seconds) }}
                            {{ $t('s') }}
                            {{ $t('Left!') }}
                        </span>
                    </div>
                </div>
                <div class="partner-row">
                    <div class="logo">
                        <img
                            width="100px"
                            height="100px"
                            v-lazy="getLogo(provider)"
                            :alt="provider['provider_name']"
                        />
                    </div>

                    <div
                        class="discount-btn"
                        v-if="provider['marketing']['discount btn']"
                    >
                        <p>{{ provider['marketing']['discount btn'] }}</p>
                    </div>

                    <div class="cta-button">
                        <button>{{ $t('Visit Site') }}</button>
                    </div>
                </div>
            </a>
        </template>
    </div>
</template>

<script>
import { ghostWriterRankingMixin, countdownTimerMixin } from '@/ghost-mixins';

export default {
    name: 'ProviderDiscount',
    mixins: [ghostWriterRankingMixin, countdownTimerMixin],
    props: {
        providers: {
            type: Array,
            default: () => [],
        },
        content: {
            default: null,
        },
    },
    methods: {
        getEndTime() {
            let endTime = new Date();
            endTime.setDate(endTime.getDate() + 1);
            endTime.setHours(0, 0, 0);
            return endTime;
        },
    },
    mounted() {
        const endTime = this.getEndTime();
        setInterval(() => {
            this.setTimer(endTime);
        }, 1000);
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.gw-ranking-provider-discount {
    display: flex;
    flex-direction: column;
    .heading {
        position: relative;
        span {
            font-weight: 400;
        }

        .ribbon {
            --r: 0.4em;
            --c: var(--gw-btn-bg-color);
            font-size: 16px;
            font-weight: 600;
            color: var(--gw-btn-text-color);
            z-index: 2;
            position: absolute;
            top: -20px;
            left: 0;
            inset-inline: calc(-1 * var(--r));
            text-align: center;
            line-height: 2;
            padding: 0 0.5em calc(2 * var(--r));
            border-radius: var(--r);
            --_g: 100% / var(--r) calc(2 * var(--r)) no-repeat;
            background: radial-gradient(
                        100% 50% at right,
                        #0005 98%,
                        #0000 101%
                    )
                    0 var(--_g),
                radial-gradient(100% 50% at left, #0005 98%, #0000 101%) 100%
                    var(--_g),
                conic-gradient(
                        from 90deg at var(--r) calc(100% - 2 * var(--r)),
                        #0000 25%,
                        var(--c) 0
                    )
                    0 0 / calc(100% - var(--r)) 100%;

            @include mq('desktop') {
                font-size: 18px;
            }
        }
    }
    .partner-row {
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: center;
        border: solid #ebe6e6;
        border-top: none;
        background: white;
        border-radius: 0 0 12px 12px;
        box-shadow: 0 0 #0000, 0 0 #0000, 0 10px 15px -3px rgb(0 0 0 / 0.1),
            0 4px 6px -4px rgb(0 0 0 / 0.1);
        border: 1px solid var(--gw-btn-bg-color);
        padding: 24px 16px 8px 16px;
        @include mq('desktop') {
            gap: 0;
            display: grid;
            grid-template-areas: 'logo discount-btn cta-btn';
            grid-template-columns: 200px auto auto;
        }

        .logo {
            display: flex;
            justify-content: center;

            @include mq('desktop') {
                display: inherit;
                justify-content: normal;
            }

            grid-area: logo;
            padding: 12px;
            font-weight: bolder;
            width: 180px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
                0 1px 2px -1px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            border: 1px solid var(--gw-discount-btn-border-color);

            img {
                object-fit: contain;
                width: 100%;
                height: 100%;
            }
        }

        .discount-btn {
            grid-area: discount-btn;
            p {
                background: var(--gw-discount-btn-bg-color, #fff);
                color: var(--gw-discount-btn-text-color);
                padding: 10px;
                font-size: 0.8em;
                text-align: center;
                font-weight: bolder;
                border-radius: 5px;
                line-height: 18px;
            }
        }
        .cta-button {
            text-align: right;
            display: flex;
            align-items: center;
            grid-area: cta-btn;

            button {
                background: transparent;
                color: var(--gw-btn-bg-color);
                text-align: center;
                padding: 10px;
                font-size: 14px;
                font-weight: bolder;
                min-height: 40px;
                width: 100%;
                border-radius: 5px;
                cursor: pointer;
                z-index: 2;
                text-decoration: underline;
                @include mq('desktop') {
                    text-align: right;
                }
            }
        }

        .icons {
            grid-area: icons;
        }
    }
}
</style>
